<div style="max-width: 800px; margin: 20px auto; padding: 20px; border-radius: 8px; box-shadow: 0 4px 6px rgba(0,0,0,0.1);">
  <h3 style="text-align: center;">Reconocimiento de Prácticas en Orden Médica</h3>

  <form (ngSubmit)="onSubmit()" style="margin-top: 20px;" [class.dragging]="isDragging">
    <div
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
      style="border: 2px dashed #4e4caf; padding: 30px; text-align: center; border-radius: 6px; cursor: pointer;"
      (click)="fileInput.click()"
    >
      <p *ngIf="!selectedFile">Arrastrá y soltá el archivo aquí o hacé clic para seleccionarlo</p>
      <p *ngIf="selectedFile">Archivo seleccionado: {{ selectedFile.name }}</p>
      <input style="visibility: hidden;"  type="file" #fileInput (change)="onFileSelected($event)" hidden required/>
    </div>
    <button color="primary" mat-raised-button type="submit" [disabled]="!selectedFile" style="margin-top: 20px;">
      Volver a procesar
    </button>
  </form>

  <!-- Mensaje de estado -->
  <div *ngIf="uploadStatus" style="margin-top: 20px; color: #4CAF50; text-align: center;">
    <p>{{ uploadStatus }}</p>
  </div>

  <!-- Resultados -->
  <div *ngIf="extractedProcedures.length > 0" style="margin-top: 20px;">
    <h4>Prácticas reconocidas: {{ getRecognizedProceduresText() }}</h4>
    <ul style="list-style: none; padding:10px; background-color: whitesmoke; border-radius: 8px; margin-top: 10px;">
      <li *ngFor="let proc of extractedProcedures" style="padding: 5px 0; font-size: 12px;">
        <span [style.color]="proc.PracticeRegion ? 'green' : 'red'">{{ proc.ExtractedProcedure }}</span>
      </li>
    </ul>
  </div>
</div>
